import React from "react";
import AdtopiaLoadLP from "../../../Utility/AdtopiaLoadLP.js";
import FormNDY_OB_UB_2_1 from "../../Forms/FormNDY_OB_UB_2_1.js";
import Header from "../../Includes/Layouts/NDY_OB_UB_2_1/Header.js";
import Footer from "../../Includes/Layouts/NDY_OB_UB_2_1/Footer.js";
import FbViewPixel from "../../../Utility/FbViewPixel.js";
import "../../../assets/NDY_OB_UB_2_1/css/NDY_OB_UB_2_1.scss";
import Section1 from "../../Includes/Layouts/NDY_OB_UB_2_1/Section1.js";
import AccordSection from "../../Includes/Layouts/NDY_OB_UB_2_1/AccordSection.js";

const NDY_OB_UB_2_1  = () => {
  return (
    <>
      <AdtopiaLoadLP pageType="LP" splitName="NDY_OB_UB_2_1" />
      <FbViewPixel />
      <div className="NDY_OB_UB_2_1">
        <Header />
        <section className="form-part" id="firstform">
          <div className="container nopad">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 nopad">
              <FormNDY_OB_UB_2_1 />
            </div>
          </div>
        </section>
        <Section1 />
        <AccordSection />
        <Footer />
      </div>
    </>
  );
};

export default NDY_OB_UB_2_1;